import { render, staticRenderFns } from "./ChangePasswordThanks.vue?vue&type=template&id=2cf56e8e&"
import script from "./ChangePasswordThanks.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports